import { useState } from 'react';
import { Button, Modal, useMantineTheme } from '@mantine/core';
import TagManager from 'react-gtm-module';
import { Icon } from '@/components/Icon/Icon';
import { SelectItem } from '@/components';
import { GoogleEvents } from '@/features/googleEvents';
import { useClientTerminology } from '@/hooks/useClientTerminology';
import featureBarClasses from '@/views/feature-bar/FeatureBar.module.css';
import type { ReleaseOption } from './ReleaseSelector';

type Props = {
  options: ReleaseOption[];
  selectedId: string;
  onChange: (id: string) => void;
};

export const ReleaseSelectorMobile = ({
  options,
  selectedId,
  onChange,
}: Props) => {
  const theme = useMantineTheme();
  const intl = useClientTerminology();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        className={`${featureBarClasses.button} ${featureBarClasses.iconOnlyButton}`}
        data-testid="release-selector-mobile"
        aria-label={intl.formatMessage({ id: 'filter.analysisDateTitle' })}
        variant="default"
        onClick={() => {
          setModalOpen(true);
          TagManager.dataLayer({
            dataLayer: { event: GoogleEvents.releaseSelectorOpened },
          });
        }}
      >
        <Icon name="Historical" size={16} />
      </Button>

      <Modal
        opened={modalOpen}
        withCloseButton={false}
        onClose={() => setModalOpen(false)}
        styles={{
          inner: {
            display: 'block',
            top: 'auto',
            bottom: 0,
            padding: 0,
          },
          content: {
            borderRadius: 0,
          },
        }}
      >
        {options.map((release, key) => (
          <Button
            key={key}
            size="lg"
            onClick={() => {
              onChange(release.value);
              setModalOpen(false);
            }}
            styles={{
              root: {
                display: 'inline-flex',
                justifyItems: 'start',
                paddingLeft: 0,
                paddingRight: 0,
              },
              label: { fontWeight: 500 },
            }}
            variant="white"
            w="100%"
          >
            <SelectItem
              label={release.label}
              selected={selectedId === release.value}
              value={release.value}
              textStyles={{
                fontWeight: theme.other.typography.weight.medium,
                textAlign: 'left',
              }}
            />
          </Button>
        ))}
      </Modal>
    </>
  );
};
